(() => {
  const root = document.documentElement;

  const morphSections = document.querySelectorAll('.fxh[data-fxh-bg]');
  if (morphSections.length && 'IntersectionObserver' in window) {
    root.classList.add('fxh-morph');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) root.style.setProperty('--fxh-page-bg', entry.target.dataset.fxhBg);
        });
      },
      { rootMargin: '-50% 0px -50% 0px' }
    );
    morphSections.forEach((section) => observer.observe(section));
  }

  document.querySelectorAll('[data-fxh-tabs]').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('[role="tab"]')];
    const select = (button) => {
      buttons.forEach((other) => {
        const selected = other === button;
        other.setAttribute('aria-selected', String(selected));
        other.tabIndex = selected ? 0 : -1;
        document.getElementById(other.getAttribute('aria-controls')).hidden = !selected;
      });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(button));
      button.addEventListener('keydown', (event) => {
        const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
        if (!step) return;
        const next = buttons[(index + step + buttons.length) % buttons.length];
        select(next);
        next.focus();
      });
    });
  });
})();
